/**
 * 客观题答案(单选/多选/判断)
 */
import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import { InputNumber, Row, Col, message } from "antd";
import classNames from "classnames";
import Editor from "components/Editor";
import { errorMessage } from "../../../../../service/service";
import { saveMarkScore } from "../../../../../service/exercise";
import _ from "underscore";
import { ResultMessage } from "../../../../../components/ResultMessage";

interface StuAnswerSubProps {
    score: string;
    analysis: string;
    stuAns: string;
    questionId: number;
    exerciseId: string;
    studentNo: string;
    stuScore: number;
    teacherComment: string;
    onOk: () => void;
}

export default function StuAnswerSub({
    score,
    analysis,
    stuAns,
    questionId,
    exerciseId,
    studentNo,
    stuScore,
    teacherComment,
    onOk
}: StuAnswerSubProps) {
    const [currentScore, setCurrentScore] = useState<number | undefined>(
        stuScore
    ); //分数
    const [comment, setComment] = useState<string>(teacherComment); //评论

    const pyScore = useMemo(() => {
        const maxScore = Number(score);

        //是特殊字符
        if (_.isNaN(Number(currentScore))) return null;

        //不是特殊字符
        if (!_.isUndefined(currentScore) && currentScore > maxScore)
            return maxScore;
        if (!_.isUndefined(currentScore) && currentScore < 0) return 0;
        return currentScore;
    }, [currentScore, score]);

    async function handleGrade(name: string, val: any) {
        try {
            const params = {
                studentNo,
                exerciseId,
                questionId,
                score: name === "score" ? val : currentScore,
                comment: name === "comment" ? val : comment
            };
            await saveMarkScore(params);
            message.success("保存成功!");
            onOk();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    return (
        <div className={style.root}>
            <div className={style.body}>
                <div className={style.row}>
                    <div className={style.label}>学生答案</div>
                </div>

                <div className={style.row}>
                    <div className={style.stuAnswer}>
                        {stuAns && (
                            <div
                                className={style.answer}
                                dangerouslySetInnerHTML={{ __html: stuAns }}
                            />
                        )}
                        {!stuAns && (
                            <span className={classNames(style.empty)}>
                                尚未作答
                            </span>
                        )}
                    </div>
                </div>

                <Row type="flex" align="middle">
                    <Col span={2}>
                        <div className={style.label}>本题得分</div>
                    </Col>

                    <Col span={3}>
                        <InputNumber
                            placeholder="请输入分值"
                            style={{ width: 100 }}
                            min={0}
                            max={Number(score)}
                            precision={1}
                            value={currentScore}
                            onChange={e => setCurrentScore(e)}
                            onBlur={() => handleGrade("score", pyScore)}
                        />{" "}
                        分
                    </Col>

                    <Col span={10}>
                        <span className={classNames(style.totalScore)}>
                            （本题{score}分）
                        </span>
                    </Col>
                </Row>

                <Row type="flex" style={{ marginTop: 20 }}>
                    <Col span={2}>
                        <div className={style.label}>本题评语</div>
                    </Col>

                    <Col span={18}>
                        <Editor
                            data={comment}
                            onChange={setComment}
                            onBlur={comment => handleGrade("comment", comment)}
                            placeholder="暂无评语，如需添加评语请点击评语输入框"
                        />
                    </Col>
                </Row>
            </div>

            <div className={style.footer}>
                <div className={style.label}>参考答案</div>

                <div className={classNames(style.rightAnswer, style.grey)}>
                    <div
                        className={style.referAnswer}
                        dangerouslySetInnerHTML={{ __html: analysis }}
                    />
                </div>
            </div>
        </div>
    );
}
